import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { useAboutUsCommon } from "@/pages-react/about-us-page/AboutUsCommon.tsx";
import { LayoutStyleTypes } from "@/util-react/layout";

export const AboutUsMobile = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = useAboutUsCommon(props.content);

  return (
    <>
      {renderContent()}
    </>
  );
}, LayoutStyleTypes.TYPE_SM);
